<template>
  <div id="otp-verification">
    <transition name="fade">
      <div
        v-if="dismissCountDown"
        class="alert alert-success save-alert"
        :class="[`alert-${alertVariant}`]"
      >
        {{ alertMessage }}
        <button
          type="button"
          class="close"
          @click="dismissCountDown = 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div class="snackbar-verification-container" v-if="isShowUnfreezeVerificationSnackbar">
        <snackbar-verification @triggerVerification="openOtpVerification" />
      </div>
    </transition>
    <verification-invitation-modal
      v-model="isOpenVerificationInvitation"
      @change:email="toggleChangeEmail('isOpenVerificationInvitation')"
      @verify="isOpenVerificationInvitation = false, isOpenVerificationOtp = true"
    />
    <change-email-modal
      v-model="isShowChangeEmail"
      @close="toggleChangeEmail()"
    ></change-email-modal>
    <base-otp-verification
      v-model="isOpenVerificationOtp"
      :hide-skip-verification="isHideSkipVerification"
      @doneVerification="isOpenVerificationOtp = false, showVerificationSuccessAlert()"
      @change:email="toggleChangeEmail('isOpenVerificationOtp')"
    />
  </div>
</template>

<script>
import BaseOtpVerification from '@/components/otpUserVerification/BaseOtpVerificationV2.vue'
import VerificationInvitationModal from '@/components/otpUserVerification/VerificationInvitationV2.vue'
import SnackbarVerification from '@/components/otpUserVerification/SnackbarVerification.vue'
import ChangeEmailModal from '@/components/otpUserVerification/ChangeEmailModal.vue'

export default {
  name: 'OtpVerification',
  components: {
    ChangeEmailModal,
    BaseOtpVerification,
    VerificationInvitationModal,
    SnackbarVerification
  },
  data () {
    return {
      isShowChangeEmail: false,
      prevModalParam: '',
      dismissCountDown: 0,
      alertMessage: 'Selamat! akun Anda telah terverifikasi',
      alertVariant: 'success'
    }
  },
  computed: {
    isOpenVerificationInvitation: {
      get () {
        return this.$store.state.user.isOpenVerificationInvitation
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_INVITATION', val)
      }
    },
    isOpenVerificationOtp: {
      get () {
        return this.$store.state.user.isOpenVerificationOtp
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_OTP', val)
      }
    },
    isHideSkipVerification: {
      get () {
        return this.$store.state.user.isHideSkipVerification
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_HIDE_SKIP_VERIFICATION', val)
      }
    },
    isVerificationMandatory: {
      get () {
        return this.$store.state.user.isVerificationMandatory
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_VERIFICATION_MANDATORY', val)
      }
    },
    isShowUnfreezeVerificationSnackbar: {
      get () {
        return this.$store.state.user.isShowUnfreezeVerificationSnackbar
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_SHOW_UNFREEZE_SNACKBAR', val)
      }
    }
  },
  methods: {
    toggleChangeEmail (prevModalParam) {
      const usedPrevModalParam = prevModalParam || this.prevModalParam
      this[usedPrevModalParam] = !this[usedPrevModalParam]
      this.isShowChangeEmail = !this.isShowChangeEmail
      this.prevModalParam = prevModalParam
    },
    showVerificationSuccessAlert () {
      this.dismissCountDown = 3
    },
    openOtpVerification () {
      this.isHideSkipVerification = true
      this.isOpenVerificationInvitation = true
    }
  }
}
</script>
<style scoped>
.snackbar-verification-container{
  position: fixed;
  top: 100px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 552px;
  z-index: 200;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.save-alert{
  width: 34%;
  min-width: 500px;
  margin: auto;
  text-align: center;
  position: fixed;
  z-index: 20;
  top: 80px;
  left: calc(50% - 250px);
}
</style>
